import * as React from 'react'

const IconParent = (props) => {
  const { color } = props
  return (
    <svg
      width={48}
      height={48}
      viewBox='0 0 48 48'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <defs>
        <path id='icon-parent_svg__a' d='M0 0h13.145v19.523H0z' />
        <path id='icon-parent_svg__c' d='M0 0h25.925v35H0z' />
      </defs>
      <g fill='none' fillRule='evenodd'>
        <g transform='translate(30.169 21.477)'>
          <mask id='icon-parent_svg__b' fill='#fff'>
            <use xlinkHref='#icon-parent_svg__a' />
          </mask>
          <path
            d='m7.934 8.92-.067.042c-.126.083-.262.149-.397.216a4.07 4.07 0 0 1-1.178.357c-.036.005-.073.008-.11.012a4.765 4.765 0 0 1-.462.032A3.794 3.794 0 0 1 2 5.793 3.797 3.797 0 0 1 5.793 2a3.797 3.797 0 0 1 3.794 3.793A3.79 3.79 0 0 1 7.934 8.92m5.163 6.965c-.289-1.412-1.017-4.063-2.645-6.663a5.756 5.756 0 0 0 1.135-3.429A5.8 5.8 0 0 0 5.793 0 5.8 5.8 0 0 0 0 5.793C0 7.076.425 8.26 1.135 9.222c-.208.332-.4.665-.58.997.348 1.094.622 2.093.825 2.943a17.67 17.67 0 0 1 1.182-2.456c.584.403 1.454.769 2.625.848l.061.005c.124.007.234.027.366.027.025 0 .045-.005.07-.006.037.001.072.006.109.006a5.75 5.75 0 0 0 3.185-.959c1.314 2.222 1.911 4.446 2.16 5.66a.396.396 0 0 1-.258.457c-1.012.355-2.716.779-5.087.779-1.825 0-3.251-.251-4.274-.529a5.656 5.656 0 0 1-.897 1.822c1.182.355 2.915.707 5.171.707 2.653 0 4.591-.485 5.749-.892a2.408 2.408 0 0 0 1.555-2.746'
            fill={color || '#262626'}
            mask='url(#icon-parent_svg__b)'
          />
        </g>
        <g transform='translate(4 7)'>
          <mask id='icon-parent_svg__d' fill='#fff'>
            <use xlinkHref='#icon-parent_svg__c' />
          </mask>
          <path
            d='M22.833 31.484c-1.97.691-5.28 1.516-9.87 1.516-4.59 0-7.902-.825-9.872-1.516a1.622 1.622 0 0 1-1.058-1.873c.507-2.47 1.76-7.112 4.6-11.634 1.026.923 2.922 2.077 5.99 2.077.06 0 .113-.008.173-.008.056 0 .11.008.166.008a9.955 9.955 0 0 0 5.136-1.431c.071-.041.135-.082.202-.123.111-.07.223-.136.33-.21.218-.146.42-.289.592-.423 2.89 4.557 4.16 9.254 4.67 11.744a1.623 1.623 0 0 1-1.059 1.873M12.963 2c4.425 0 8.026 3.601 8.026 8.026a8.02 8.02 0 0 1-3.436 6.576c-.107.072-.212.144-.334.217-.046.03-.094.058-.14.086-.98.564-2.423 1.111-4.315 1.139-4.334-.107-7.829-3.658-7.829-8.018C4.935 5.601 8.536 2 12.962 2m12.89 27.209c-.554-2.694-1.956-7.838-5.182-12.779a9.976 9.976 0 0 0 2.32-6.404C22.99 4.498 18.49 0 12.961 0 7.433 0 2.935 4.498 2.935 10.026c0 2.434.873 4.666 2.32 6.404C2.027 21.37.625 26.514.074 29.209a3.647 3.647 0 0 0 2.354 4.162C4.545 34.114 8.09 35 12.962 35s8.417-.886 10.533-1.629a3.648 3.648 0 0 0 2.356-4.162'
            fill={color || '#262626'}
            mask='url(#icon-parent_svg__d)'
          />
        </g>
      </g>
    </svg>
  )
}

export default IconParent
